import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Download a file from an authenticated API endpoint.
 *
 * A raw `window.open(apiUrl)` / anchor navigation cannot attach the
 * Authorization header, so cross-domain deployments (frontend on
 * blueprint.seerios.ai, backend on *.emergent.host) fail with
 * "Not authenticated" because the browser won't send the auth cookie
 * third-party either. Fetching through axios routes the request through
 * the Bearer-token interceptor + credentials, then we trigger a download
 * from the resulting blob.
 *
 * @param {string} path - API path beginning with `/api/...`
 * @param {string} fallbackName - filename used if no Content-Disposition
 */
export async function downloadAuthedFile(path, fallbackName) {
  const resp = await axios.get(`${API_URL}${path}`, {
    withCredentials: true,
    responseType: 'blob',
  });

  let filename = fallbackName;
  const cd = resp.headers['content-disposition'];
  if (cd) {
    const m = cd.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/i);
    if (m) filename = decodeURIComponent(m[1]);
  }

  const url = window.URL.createObjectURL(resp.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
